$(document).ready(function() {


  $('#add-to-cart-form').on('submit', function(evt) {
    evt.preventDefault();
    var validated = true;
    $('.hp-swatches:not([data-fabric-type-colors])').each(function() {
      if ( $(this).find('input:checked').length == 0 ) {
        $('summary .swatch-error-msg').show();

// This opens the <details> element (modal) when no variant is sselected and add to cart button is clicked
        var modal = $(this).closest('.hp__modal');
if (modal.length > 0) {
    modal.prop('open', true); 
}
        validated = false;
      }
    });
    if (!validated) {
      return false;
    }
    $('input:checked', this).each( function(index) {
      $(this).attr('disabled', false);
    }).filter(function() {
        return !this.value;
    }).each( function(el) {
      var name = $(this).attr('name').replace('[id]','');
      $('[name^="' + name +  '"]').attr('disabled', true);
    });
    $(this).unbind('submit').submit();
  });
  $(window).on('hp:VariantSelected', function(evt, variant) {
    setAdditionalItemPrice();
    // rest product options
    //console.log(evt);
    $('.hp__modal-content:hidden input:checked').prop('checked', false);
    $('.selected-options').html('')

    var sizeOptionName = variant.title.split(' /')[0];
    //console.log(sizeOptionName, sizeOptionName.indexOf('Single') < 0);

    $('[data-js-vars]').each( function(index) {
      var addOnVariants = $(this).data('js-vars');
      var addOnElId = $(this).attr('id');
      // console.log(sizeOptionName, addOnVariants);
      if (sizeOptionName in addOnVariants) {
        var totalPriceText = Shopify.formatMoney(addOnVariants[sizeOptionName].price, "£{{amount}}");
        $("label[for='" + addOnElId + "']").parent().find('.variant_price').text('+' + totalPriceText);
        $(this).val(addOnVariants[sizeOptionName].id);
        var isAvailable = addOnVariants[sizeOptionName].available;
        if (isAvailable) {
          $(this).attr('disabled', false);
          $('[for="'+ addOnElId +'"]').parents('.swatch-element').eq(0).addClass('available').removeClass('soldout')
        } else {
          $(this).attr('disabled', true);
          $('[for="'+ addOnElId +'"]').parents('.swatch-element').eq(0).removeClass('available').addClass('soldout')
        }
      }
    });

    //2 side draw storage to show as only option only on single
    //debugger
    console.log('sizeOptionName', sizeOptionName);
    if (sizeOptionName.toLowerCase().indexOf('single') >= 0 && $('[data-item-name*="2-drawers-"]').length > 0) {
      $('[data-item-name="2-drawers-right-side"]').first().parent().find('[data-item-name]').hide()
      $('[data-item-name="2-drawers-right-side"], [data-item-name="2-drawers-left-side"], [data-item-name="side-lift-ottoman-base"], [data-item-name="front-lift-ottoman-base"]').show();
      $('[data-item-name="2-drawers-right-side"]').first().parent().find('[data-item-name]').last().show()
    } else {
      $('[data-item-name*="2-drawers-"]').first().parent().parent().find('[data-item-name]').show()
    }

    var ottomStorageOptions = $('[data-value*="Ottoman Storage"]')
    //show up only the respective Ottoman Storage
    if (ottomStorageOptions.length > 0) {
      ottomStorageOptions.prop('checked', false).trigger('change')
      $('[data-ottoman-storage]:not(:last-child)').hide();
      //console.log(sizeOptionName);
      $('[data-ottoman-storage="'+ sizeOptionName.toLowerCase() +'"]').show();
    }

    $('.js-swatch-text').text('');

  });

  $('body').on('change', '[data-fabric-type]', function (evt) {

    var fabricType = this.getAttribute('data-fabric-type');
    var inputName = $('[data-fabric-type-colors="'+fabricType+'"] [data-name]').attr('data-name');
    $('[data-fabric-type-colors]').hide();
    $('[data-fabric-type-colors] [name]').attr('name', '');
    $('[data-fabric-type-colors="'+fabricType+'"]').show();
    $('[data-fabric-type-colors="'+fabricType+'"] [data-name]').attr('name', inputName);
  });

  var setAdditionalItemPrice = function () {
    if ($('[name="option-1"]').length == 0) {
      return
    }
    var slectedVar = $('#product-selectors option:selected');
    var noneOptionVal = $('[name="option-1"]').last().val();
    var option0Val = $('[name="option-0"]').val();
    var noneOptionPrice = $('#product-selectors option[data-title="'+ option0Val +' / ' + noneOptionVal +'"]').data('price');
    //console.log('noneOptionPrice', noneOptionPrice);
    $('[name="option-1"]').each(function() {
      var option1Val = this.value;
      var varName = option0Val +' / ' + option1Val;
      var option = $('#product-selectors option[data-title="'+ varName +'"]');
      var optionPrice = option.data('price');
      var addPrice = optionPrice - noneOptionPrice;
      // console.log('optionPrice', optionPrice);
      // $('.prices .price').html(Shopify.formatMoney(optionPrice, '+' + "£{{amount}}"));
      $(this).parent().find('.swatch-price').html(Shopify.formatMoney(addPrice, '+' + "£{{amount}}"));
    })
    $('.swatch-price').last().css('visibility','hidden')
  };

  var hpModal = function (){
    if ($('.hp__modal-content').length == 0) {
      return;
    }
    // var noneVal = $('[name="option-1"]').last().val();
    // $('[name="option-1"]').val(noneVal).trigger('change');
    function openModal () {
      //console.log('openModal');
      //document.querySelector('.hp__modal').setAttribute('open','');
      $('body').addClass('cbp-spmenu-push-toright');
      $('.swatch-error-msg').hide();
      // if no available options then select the "No" option

    }
    function closeModal () {
      document.querySelector('.hp__modal').removeAttribute('open');
      $('body').removeClass('cbp-spmenu-push-toright');
    }
    function validateOptions ()  {
      var validated = true;
      $('.swatch-error-msg').hide();
      $('.hp-swatches:visible').each(function() {
        if ( $(this).find('input:checked').length == 0 ) {
          $(this).find('.swatch-error-msg').show();
          validated = false;
        }
      })
      return validated;
    }
    function showSelectedItems (){

      // get selected fabric
      var fabricSummery = $('[data-custom-option="fabric"] .selected-options');
      var selectedFabricType = $('[name="properties[fabric]"]:checked').val();
      var selectedFabricColor = $('[name="properties['+ selectedFabricType +']"]:checked').val();
      var selectedFabricImg = $('[name="properties['+ selectedFabricType +']"]:checked + label img').first().clone();
      fabricSummery.html('<div class="option-img">  </div> <div class="option-text"> '+ selectedFabricType + ' - ' + selectedFabricColor +' </div>')
      fabricSummery.find('.option-img').append(selectedFabricImg);
      var extraOptionsSummery = $('[data-custom-option]:not([data-custom-option="fabric"]) .selected-options');
      extraOptionsSummery.each(function(i, val) {
        var optionName = $(this).data('custom-option');
        var $selectedOption = $('[name="properties['+ optionName +']"]:checked');
        if ($selectedOption.length == 0) {
          // add 1 to the inex as the fabric swaches not selected
          $selectedOption = $('.hp-swatches:not([data-fabric-type-colors])').eq(i+1).find('input:checked');
        }
        var selectedOption = $selectedOption.data('value');
        var selectedOtionId = $selectedOption.attr('id');
        var selectedOptionImg = $('label[for="'+ selectedOtionId +'"] > img:first').clone();
        var selectedOptionPrice = $('label[for="'+ selectedOtionId +'"]').parent().find('.variant_price').text().trim();
        var selectedOptionPrice = selectedOptionPrice === "" ? "" : selectedOptionPrice + ' - ';
        $(this).html('<div class="option-img">  </div> <div class="option-text"> '+ selectedOptionPrice + selectedOption  +' </div>')
        $(this).find('.option-img').append(selectedOptionImg);
      });

    }

    $('.hp__modal-content input').on('change', function() {
      var $swatchText =  $(this).parents('.hp-swatches').find('.js-swatch-text');
      //console.log($swatchText);
      var addText = this.getAttribute('data-value').indexOf('No ') > -1 ?  '- ' + this.getAttribute('data-value') : '- Add ' + this.getAttribute('data-value')
      $swatchText.text(addText);
    });
    $('.hp__modal summary').on('click', function(evt) {
      if (!evt.target.classList.contains('hp__modal-closer')) {
        openModal();

        console.log(evt.target.classList);

        $('.hp-swatches input').removeAttr("readonly");
        setTimeout(function(){
          document.querySelector('.hp__modal-content').scrollTo(0, 0);
        }, 50);
        setTimeout(function(){
          $('.swatch.hp-swatches').each(function (){
            var availableInputs = $(this).find('.swatch-element:visible:not(.soldout)');
            if ( availableInputs.length == 1 ) {
              //console.log('availableInputs', availableInputs);
              availableInputs.find('label[for*="none"]').trigger('click');
            }
          })
        }, 200);

      }
    });
    var isConfirmed = 0;
    $('.modal-popup__close').on('click', function(){
      // uncheck all options as user closed the iput by clicking "X" button
      if (validateOptions() && isConfirmed) {
        closeModal();
        showSelectedItems();
      } else {
        $('[data-fabric-type-colors]').hide();
        $('.hp-swatches input').removeAttr("checked");
        $('.js-swatch-text').text('');
        closeModal();
        isConfirmed = 0;
      }
      return false;
    });
    $('.close-hp-modal').on('click',function(){
      //validateOptions();
      if (validateOptions()) {
        $('.swatch-error-msg').hide();
        isConfirmed = 1;
        closeModal();
        showSelectedItems();

      } else {
        $('.selected-options').empty();
        $(".hp__modal-content .swatch-error-msg:visible").eq(0).parents('.hp-swatches').get(0).scrollIntoView();
      }
    });
    $('.size-selector').on('change', function(){
      isConfirmed = 0;
    })

  }
  hpModal();
  $('.size-selector').on('change', function(){
    var sizeVal = this.value;
    // $('[data-option-index="0"] input[name="option-0"]').val(sizeVal).trigger('change');
    $('[data-option-index="0"] input[name="option-0"][value="'+ sizeVal +'"]').attr('checked', true).trigger('change');
    $('.swatch-error-msg').hide();
    $('[data-fabric-type-colors]').hide();
    $('.hp-swatches input').removeAttr("checked");
  });

});
window.onload = function () {  // clear save doptions from before
  if ($('.hp-swatches input').length > 0) {
  //  $('.hp-swatches input').removeAttr( "checked" );
  }
}
